module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3r4r8r-1e0b68437592f54ac6fe666f5be020fa.svg";